import React, { useState } from 'react';
import {
  MDBNavbar,
  MDBNavbarNav,
  MDBNavbarToggler,
  MDBNavbarLink,
  MDBContainer,
  MDBIcon,
  MDBCollapse,
  MDBNavbarBrand
} from 'mdb-react-ui-kit';


export default function App() {
  const [openNavSecond, setOpenNavSecond] = useState(false);

  return (
    <MDBNavbar expand='lg' light 
      style={{ backgroundColor: "rgba(48, 62, 96, 1)",
                position: 'fixed', 
                top: 0, 
                width: '100%', 
                zIndex: 1000,
                }}>
      <MDBContainer fluid>
        <MDBNavbarBrand href='#'>
                  <img
                    src='/logo_sh_orange.png' // Remplace avec le bon chemin
                    alt='Logo'
                    style={{
                      height: '10vh',  // Hauteur proportionnelle à l'écran
                      maxHeight: '60px', // Hauteur max pour éviter une image trop grande
                      width: 'auto', // Garde les proportions
                    }}
                  />
                </MDBNavbarBrand>
        <MDBNavbarToggler
          aria-expanded='false'
          aria-label='Toggle navigation'
          onClick={() => setOpenNavSecond(!openNavSecond)}
        >
          <MDBIcon icon='bars' fas />
        </MDBNavbarToggler>
        <MDBCollapse navbar open={openNavSecond}>
          <MDBNavbarNav>
            <MDBNavbarLink href='#projet' className='navbar-link-hover text-white mx-3' style={{ color: '#ffffff', fontFamily: 'Consolas, monospace' }}>
              Le Projet
            </MDBNavbarLink>
            <MDBNavbarLink href='#equipe' className='navbar-link-hover text-white mx-3' style={{ color: '#ffffff', fontFamily: 'Consolas, monospace' }}>L'Equipe</MDBNavbarLink>
            <MDBNavbarLink href='#programme' className='navbar-link-hover text-white mx-3' style={{ color: '#ffffff', fontFamily: 'Consolas, monospace' }}>Le Programme</MDBNavbarLink>
            <MDBNavbarLink href='#bateaux' className='navbar-link-hover text-white mx-3' style={{ color: '#ffffff', fontFamily: 'Consolas, monospace' }}>Les Bateaux</MDBNavbarLink>
          </MDBNavbarNav>
        </MDBCollapse>
      </MDBContainer>
    </MDBNavbar>

  );
}